import { trans } from '../../utils/utilsTrans'
import Input from '../UI/Inputs/Input'
import CustomSelect from '../UI/Inputs/Select'

const options = [
  { value: 5, label: 5 },
  { value: 10, label: 10 },
  { value: 20, label: 20 },
]

const Pagination = ({
  firstData,
  lastData,
  total,
  onChangeLimit,
  onChangePage,
  maxPage,
  limit,
  page,
}) => {
  return (
    <div className='flex justify-between w-full items-center px-8 py-8 mt-auto'>
      <span className='text-greyLight2 text-sm leading-sm'>
        {firstData}-{lastData} {trans('on_results')} {total}
      </span>
      <div className='flex items-center'>
        <span className='text-grey text-sm leading-sm mr-16 hidden lg:block'>
          {trans('results_per_page')}
        </span>
        {onChangeLimit ? (
          <CustomSelect
            menuPlacement='top'
            value={limit}
            onChange={(value) => onChangeLimit(value)}
            options={options}
          />
        ) : (
          <Input disabled={true} value={limit} extraClass='w-[50px]' />
        )}
        <div className='flex items-center gap-16 ml-16'>
          <button
            type='button'
            onClick={() => (page !== 0 ? onChangePage(0) : null)}
          >
            <i
              className={`icon icon-chevron-left-double w-24 h-24 flex items-center justify-center ${
                page !== 0
                  ? 'text-grey cursor-pointer hover:text-primary'
                  : 'text-greyLight5'
              }`}
            />
          </button>
          <button
            type='button'
            onClick={() => (page !== 0 ? onChangePage(page - 1) : null)}
          >
            <i
              className={`icon icon-chevron-left w-24 h-24 flex items-center justify-center ${
                page !== 0
                  ? 'text-grey cursor-pointer hover:text-primary'
                  : 'text-greyLight5'
              }`}
            />
          </button>
          <button
            type='button'
            onClick={() => (page < maxPage ? onChangePage(page + 1) : null)}
          >
            <i
              className={`icon icon-chevron-right w-24 h-24 flex items-center justify-center ${
                page < maxPage
                  ? 'text-grey cursor-pointer hover:text-primary'
                  : 'text-greyLight5'
              }`}
            />
          </button>
          <button
            type='button'
            onClick={() => (page < maxPage ? onChangePage(maxPage) : null)}
          >
            <i
              className={`icon icon-chevron-right-double w-24 h-24 flex items-center justify-center ${
                page < maxPage
                  ? 'text-grey cursor-pointer hover:text-primary'
                  : 'text-greyLight5'
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  )
}

export default Pagination
